module.exports = __webpack_public_path__ + "img/lily.00a98208.jpg";